<template>
   <div class="menuWrapper">
      <div class="menuContainer" :class="{ menuContainerOpen: menuIsOpen }">
         <span v-if="menuIsOpen">
            <span
               class="imgContainer"
               v-if="options.actions.includes('payments')"
               v-tippy="{ placement: 'top' }"
               :title="titles.payments"
               @click="emit('payments')"
            >
               <img
                  src="/clientV2/static/gfx/paymentAction.svg"
                  style="width: 18px"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-if="options.actions.includes('message')"
               v-tippy="{ placement: 'top' }"
               :title="titles.message"
               @click="$emit('message')"
            >
               <img
                  src="/clientV2/static/gfx/messageAction.svg"
                  :class="{ menuItemShow: menuIsOpen }"
                  class="iconBtn transition menuItem"
               />
            </span>

            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.payment"
               @click="$emit('payment')"
               v-if="options.actions.includes('payment')"
            >
               <img
                  src="/clientV2/static/gfx/paymentAction.svg"
                  :class="{ menuItemShow: menuIsOpen }"
                  class="iconBtn transition menuItem"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.door"
               @click="emit('door')"
               v-if="options.actions.includes('door')"
            >
               <img
                  src="/clientV2/static/gfx/black-door.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.edit"
               @click="emit('edit')"
               v-if="options.actions.includes('edit')"
               @mouseover="toggleSubMenu(false)"
            >
               <img
                  src="/clientV2/static/gfx/edit.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.credit"
               @click="emit('credit')"
               v-if="options.actions.includes('credit')"
            >
               <img
                  src="/clientV2/static/gfx/credit.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.takalot"
               @click="emit('takalot')"
               v-if="options.actions.includes('takalot')"
            >
               <img
                  src="/clientV2/static/gfx/takalotw.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.add"
               @click="emit('add')"
               v-if="options.actions.includes('add')"
            >
               <img
                  src="/clientV2/static/gfx/actionPlus.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.download ? titles.download : 'שמירה למחשב'"
               @click="emit('download')"
               v-if="options.actions.includes('download')"
            >
               <img
                  src="/clientV2/static/gfx/actionDownload.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.preview"
               @click="emit('preview')"
               v-if="options.actions.includes('preview')"
            >
               <img
                  src="/clientV2/static/gfx/Preview.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="'עדכון הפקדות'"
               @click="emit('viewchecks')"
               v-if="
                  options &&
                  options.actions &&
                  options.actions.includes('viewChecks')
               "
            >
               <img
                  src="/clientV2/static/gfx/checks.svg"
                  style="margin-left: 5px"
                  :class="{ menuItemShow: menuIsOpen }"
                  class="iconBtn transition menuItem circle"
               />
            </span>

            <div
               class="iconBtn inline"
               style="position: relative; margin-left: 5px"
               @click="emit('checks')"
               v-if="
                  options &&
                  options.options &&
                  options.options.checks &&
                  options.options.checks.shouldDisplay
               "
            >
               <div
                  :class="{ menuItemShow: menuIsOpen }"
                  class="checksNumber transition menuItem"
               >
                  {{ options.options.checks.number }}
               </div>
               <img
                  :class="{ menuItemShow: menuIsOpen }"
                  src="/clientV2/static/gfx/checks.svg"
                  style="margin-left: 5px"
                  class="iconBtn transition menuItem circle"
                  v-tippy="{ placement: 'top' }"
                  :title="'צפה בשיקים סרוקים'"
               />
            </div>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="'הוספת הערת תשלום'"
               @click="emit('addNewNote')"
               v-if="options.actions.includes('notes')"
            >
               <img
                  src="/clientV2/static/gfx/notes-icon.svg"
                  :class="{ menuItemShow: menuIsOpen }"
                  class="iconBtn transition menuItem"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="'הדפסה'"
               @click="emit('print')"
               v-if="options.actions.includes('print')"
            >
               <img
                  src="/clientV2/static/gfx/print.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.send"
               @click="emit('send')"
               v-if="options.actions.includes('send')"
            >
               <img
                  src="/clientV2/static/gfx/Messages.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.sendAccounting"
               @click="emit('sendAccounting')"
               @mouseover="toggleSubMenu(true)"
               v-if="options.actions.includes('sendAccounting')"
            >
               <img
                  src="/clientV2/static/gfx/Messages.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
               <div
                  class="filterMenu subGroup"
                  v-if="options.openSub && options.items"
               >
                  <div
                     @click="
                        $emit('transform', { data: item.action })
                        menuToggle = !menuToggle
                     "
                     class="filterList-item"
                     v-for="(item, j) in options.items"
                     :key="j"
                  >
                     {{ item.label }}
                  </div>
               </div>
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="'הסר רשומה'"
               @click="emit('remove')"
               v-if="
                  options &&
                  options.actions &&
                  options.actions.includes('remove')
               "
            >
               <img
                  src="/clientV2/static/gfx/x.svg"
                  style="margin-left: 7px; width: 15px"
                  :class="{ menuItemShow: menuIsOpen }"
                  class="iconBtn transition menuItem circle"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.sendReverse"
               @click="emit('sendReverse')"
               v-if="options.actions.includes('sendReverse')"
            >
               <img
                  src="/clientV2/static/gfx/Messages.svg"
                  class="sendReverse iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.detailReport"
               @click="emit('detailReport')"
               v-if="options.actions.includes('detailReport')"
            >
               <img
                  src="/clientV2/static/gfx/detailReport.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.delete"
               @click="emit('delete')"
               v-if="options.actions.includes('delete')"
               @mouseleave="toggleSubMenu(false)"
            >
               <img
                  src="/clientV2/static/gfx/Delete03.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.delete2"
               @click="emit('delete2')"
               v-if="options.actions.includes('delete2')"
               @mouseleave="toggleSubMenu(false)"
            >
               <img
                  src="/clientV2/static/gfx/trashWhite.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.save"
               @click="emit('save')"
               v-if="options.actions.includes('save')"
            >
               <img
                  src="/clientV2/static/gfx/save.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
            <span
               class="imgContainer"
               v-tippy="{ placement: 'top' }"
               :title="titles.autoClosePayment"
               @click="emit('autoClosePayment')"
               v-if="options.actions.includes('autoClosePayment')"
            >
               <img
                  src="/clientV2/static/gfx/connect.svg"
                  class="iconBtn transition menuItem"
                  :class="{ menuItemShow: menuIsOpen }"
               />
            </span>
         </span>
      </div>
      <div class="actionsMenu">
         <img
            v-if="!menuIsOpen"
            src="/clientV2/static/gfx/dotsClose.svg"
            @click="toggleMenu(true)"
            :class="{ openMenu: menuIsOpen }"
         />
         <img
            v-else
            src="/clientV2/static/gfx/dotsOpen.svg"
            @click="toggleMenu(true)"
            />
      </div>
   </div>
</template>

<script>
export default {
   name: 'ActionsMenu',
   props: ['model', 'placeholder', 'options', 'style'],
   data() {
      return {
         iframeUrl: false,
         menuIsOpen: false,
         titles: {
            add: 'הוספה',
            edit: 'עריכה',
            door: 'עריכת דירה',
            delete: 'מחיקה',
            delete2: 'מחיקה',
            send: 'שלח',
            sendReverse: 'החזר',
            payments: 'תשלומים',
            message: 'הודעות',
            save: 'שמירה',
            takalot: 'פתח',
            detailReport: 'דוח מפורט',
            preview: 'לצפייה והדפסה',
            autoClosePayment: 'סגירת תשלומים אוטומטית',
         },
         uId: Math.floor(Math.random() * (9999999 - 1) + 1),
      }
   },
   created() {
      if (this.options.titles) {
         for (let k in this.options.titles) {
            this.titles[k] = this.options.titles[k]
         }
      }
      this.$root.$on('openedAction', (uId) => {
         if (uId != this.uId) {
            this.menuIsOpen = false
         }
      })
   },
   methods: {
      toggleSubMenu(value) {
         this.$set(this.options, 'openSub', value)
         this.$forceUpdate()
      },
      toggleMenu(shouldEmit) {
         if (shouldEmit) this.$root.$emit('openedAction', this.uId)
         this.menuIsOpen = !this.menuIsOpen
         this.$set(this.options, 'openSub', false)
      },
      emit(data) {
         this.toggleMenu(true)
         this.$emit(data)
      },
   },
}
</script>

<style scoped lang="less">
@import '../../assets/css/style.less';

.checksNumber {
   text-align: center;
   color: @white;
   background: @blue-dark;
   border-radius: 50%;
   border: @border;
   position: absolute;
   top: 12px;
   right: 18px;
   width: 15px;
   height: 15px;
   font-size: 11px;
   z-index: 1;
}

.circle {
   margin-left: 5px;
   border-radius: 50%;
}

.menuWrapper {
   position: absolute;
   left: 0px;
}

.menuContainer {
   z-index: 99;
   border: 0 solid @blue;
   border-radius: 18px;
   display: flex;
   flex-direction: column;
   transition: all 0.15s ease-in;
   /*overflow: hidden;*/
   width: 0;
   white-space: nowrap;
   background: @white;
   right: 33px;
   opacity: 0;
   position: absolute;

   img {
      width: 22px;
      margin: 0 auto 10px;

      &:last-of-type {
         margin: 0 auto;
      }
   }
}

.menuItem {
   transition: all 0.15s ease-in;
   transform: scale(0);
}

.actionsMenu {
   position: relative;
   display: flex;
   z-index: 10;
   cursor: pointer;

   img {
      width: 26px;
   }
}

.menuItem {
   cursor: pointer;
}

.menuContainerOpen {
   transition: all 0.15s ease-out;
   opacity: 1 !important;
   border: solid 1px @blue;
   width: 29px;
   padding: 10px 0;
}

.menuItemShow {
   transition: all 0.15s ease-out;
   transform: scale(1);
}

.menuItemShow.sendReverse {
   transform: scale(1) rotateY(180deg);
}

.imgContainer {
   display: flex;
   padding: 5px 0;
   width: 100%;
   align-items: center;
   justify-content: center;
}
.filterMenu {
   max-height: 140px;
   overflow-y: auto;
   top: 0;
   right: -150px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/uiActionsMenu.vue